import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <i className="fas fa-exclamation-triangle text-8xl text-primary-800 mb-4"></i>
        </div>
        
        <h1 className="text-6xl font-display font-bold text-gray-900 mb-4">404</h1>
        
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Page non trouvée
        </h2>
        
        <p className="text-gray-600 mb-8 max-w-md">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block bg-primary-800 text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors"
          >
            <i className="fas fa-home mr-2"></i>
            Retour à l'accueil
          </Link>
          
          <div className="mt-4">
            <Link
              to="/produits"
              className="inline-block text-primary-800 hover:text-primary-600 mx-4"
            >
              Voir les produits
            </Link>
            <Link
              to="/artisans"
              className="inline-block text-primary-800 hover:text-primary-600 mx-4"
            >
              Voir les artisans
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;